import React from "react"
import { FormattedMessage } from "react-intl"
import { TextField } from "@walmart-web/livingdesign-components"

interface InputProps {
	id: string
	value: string
	data: Record<string, any>
	setData: (value: any) => void
	disabled?: boolean
	validators: Array<(value: any) => [boolean, string]>
}

const Input: React.FC<InputProps> = ({
	id,
	value,
	data,
	setData,
	disabled,
	validators,
}) => {
	const functionValidate = validators.find((func) => {
		const [error] = func(value)
		return error
	})

	const [showError, idText] = functionValidate
		? functionValidate(value)
		: [false, ""]

	return (
		<TextField
			UNSAFE_className="input"
			value={value}
			label=""
			onChange={(value) => setData({ ...data, [id]: value.target.value })}
			disabled={disabled}
			error={showError && <FormattedMessage id={idText} />}
		/>
	)
}

export default Input
